import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import toast, { Toaster } from "react-hot-toast";

import ToastPopup from "../../../custom/toastPopup/toastPopup";
import { generateStyles } from "../../../../utils/generateToastStyles";
import { reducerSingleVacancyStatus, reducerSingleVacancyStatusMessage } from "../../../../redux/reducer/recruiting/reducers/reducerSingleVacancy";
import { AppDispatch } from "../../../../redux/reducer/store";

const VacancyToast = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { clientsStatus, clientsStatusMessage } = useSelector(
    (state: any) => state.recruiting.singleVacancy
  );

  useEffect(() => {
    const requestStatusOptions = [
      {
        status: 201,
        successMessage: clientsStatusMessage,
      },
      {
        status: 200,
        successMessage: clientsStatusMessage,
      },
      {
        status: 400,
        errorMessage: clientsStatusMessage,
      },
      {
        status: 1,
        errorMessage: clientsStatusMessage,
      },
      {
        status: 500,
        errorMessage: 'Ошибка на стороне сервера',
      },
    ];

    requestStatusOptions.forEach((option: { status: number, successMessage?: string, errorMessage?: string }) => {
      if (clientsStatus !== null && clientsStatus === option.status) {
        toast.dismiss();

        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={!!option.successMessage}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(!!option.successMessage)
        );
      } else return
    });

    setTimeout(() => {
      dispatch(reducerSingleVacancyStatus(null));
      dispatch(reducerSingleVacancyStatusMessage(null));
    }, 5000);
  }, [dispatch, clientsStatus, clientsStatusMessage]);

  return (
    clientsStatus && (
      <Toaster
        position='top-center'
        toastOptions={{
          duration: 5000,
        }}
      />
    )
   );   
};

export default VacancyToast;
